<div class="one-center-header">
  <ng-content></ng-content>
</div>
